// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__DesQY","fileDisabled":"File_fileDisabled__GW4-r"};